import { render, staticRenderFns } from "./VideoRecorderConfiguration.vue?vue&type=template&id=5926851d&scoped=true&"
import script from "./VideoRecorderConfiguration.vue?vue&type=script&lang=js&"
export * from "./VideoRecorderConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./VideoRecorderConfiguration.vue?vue&type=style&index=0&id=5926851d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5926851d",
  null
  
)

export default component.exports